import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import siteSettingsAPI from "../../api/siteSettingAPI";
import { saveUserInfo } from "features/User/userSlice";
import { getInfoResponse } from "utils/common";

const getSiteSettings = createAsyncThunk(
  "GET_SITE_SETTINGS",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await siteSettingsAPI.getSiteSettings();
      dispatch(saveUserInfo(getInfoResponse(res)));
      if( res.sorrypage == '0') {
        return {
          data: { isInLine: true }
        };
      }
      return {
        data : res.data
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  site_setting: null,
  site_setting1: null,
  site_setting2: null,
  isInLine: false
};

const navbarSlice = createSlice({
  name: "navbar",
  initialState,
  extraReducers: {
    [getSiteSettings.fulfilled]: (state, action) => {
      state.site_setting = action.payload.data.site_setting;
      state.site_setting1 = action.payload.data.site_setting1;
      state.site_setting2 = action.payload.data.site_setting2;
      state.isInLine = action.payload.data.isInLine;
    },
  },
});

const { reducer } = navbarSlice;
export { getSiteSettings };
export default reducer;
